import { Amplify } from "aws-amplify";
import { aws_configs } from "./awsConfig";

Amplify.configure(aws_configs, {
  ssr: true, // required when using Amplify with Next.js
});
